import { ChevronDown, Handshake} from 'lucide-react'
import styles from './Modules.layout.module.css'
import { NavLink, Outlet } from 'react-router'
import { useState, type ReactNode } from 'react'
import UserSettings from '../../auth/user-settings/UserSettings'
import { useAuthLoaderData } from '@/loaders/auth/useAuthLoaderData'

const modules = [  
  /**
  {
    label: 'Gestion Humana', 
    path: 'third-partis',
    icon: <PersonStanding  width={20} height={20}/>
  }, 
   */   
  {
    label: 'Proveedores', 
    path: 'providers',
    icon: <Handshake  width={0} height={0}/>
  },
  /**
  {
    label: 'Recursos', 
    path: 'thirdsos',
    icon: <BookOpen  width={20} height={20}/>
  }, 
  */ 
]

type Props = {
  children?: ReactNode
}

export default function ModulesLayout({children} : Props) {    
  const username = useAuthLoaderData()?.user?.name

  const [authSettingsOpen, setAuthSettingsOpen] = useState(false)


  const handleAuthSettings = () => {    
    setAuthSettingsOpen(!authSettingsOpen)  
  }

  return (
    <div className={styles.container}>
      <nav className={styles.topbar}>
        <div className={styles.logo}>          
          <span className={styles.text}>
            Proobi
          </span>
        </div>
        
        <div className={styles.modules}>
          <UserSettings isActive={authSettingsOpen} onBlur={() => setAuthSettingsOpen(false)}/>        
          { modules.map((module) => (              
              <NavLink                   
                key={`module-${module.path}`}
                to={`${module.path}`} 
                className={({isActive}) => `
                  ${isActive ? styles.active : ""} 
                  ${styles.module}
                `}
              >
                <span className={styles.text}>
                  {module.icon}
                  {module.label}
                </span> 
              </NavLink>  
            )
          )}
          
          <div onMouseDown={(e) => {e.stopPropagation()}} onClick={handleAuthSettings} className={styles.user}>
            <div className={styles.img}>
              {username?.charAt(0)}
            </div>
            <span className={styles.texts}> 
              <span className={styles.username}>{username}</span>              
            </span>
            <ChevronDown width={12} height={12}/>
          </div>
        </div>
      </nav>
      <div className={styles.outlet}>
        {children ?? <Outlet />}
      </div>
    </div>
  )
}